import { render } from "./purchaseOrderList.vue?vue&type=template&id=284c607f&scoped=true"
import script from "./purchaseOrderList.vue?vue&type=script&lang=js"
export * from "./purchaseOrderList.vue?vue&type=script&lang=js"

import "./purchaseOrderList.vue?vue&type=style&index=0&id=284c607f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-284c607f"

export default script